import { Paper, Select, Table, TableBody, TableCell, TableRow, Chip , TextField, Typography , Button ,  IconButton, InputAdornment } from '@mui/material';
import React, { useEffect, useState, useContext , useMemo } from 'react';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ApiService from '../../functions/apiService';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import MyTable from './MyTable';
import Modal from 'react-bootstrap/Modal';
import SearchIcon from "@mui/icons-material/Search";
import { toast } from 'react-toastify';

export function QuickAssign(props) {
  const { date, setAssignModal, EmpIds, loadData, backFunction, isNightShift , shift} = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([])
  const [employee, setEmployee] = useState('')
  const [selectedEmp, setSelectedEmp] = useState([])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [search , setSearch] = useState('');
  const mode = localStorage.getItem('mode')

  const columns = [
    {
      style: { fontSize: 12 },
      field: 'name',
      headerName: '',
      width: 220,
      sortable: false,
      renderCell: (params) => (<Typography key={1} fontWeight={700} fontSize={16}>
        {params?.row?.employee?.employee_assignment?.EA_Rank} {params?.row?.employee?.fullName}
      </Typography>)
    },
    {
      style: { fontSize: 12 },
      field: 'seniority',
      headerName: '',
      width: 90,
      sortable: false,
      renderCell: (params) => (
        `${params?.row?.employee?.EHd_Seniority}`
      )
    },
    {
      style: { fontSize: 12 },
      field: 'hours',
      headerName: '',
      width: 90,
      sortable: false,
      renderCell: (params) => (
        `${params?.row?.Hours || '0'}`
      )
    },
    {
      style: { fontSize: 12 },
      field: 'shift',
      headerName: '',
      width: 200,
      sortable: false,
      renderCell: (params) => (
        `${moment(params?.row.Shift_Date).format('dddd')} (${params?.row?.shift?.Shift}) ${params?.row?.Value != 'FULLTIME' ? 'on ' + params.row.Value : ''}`
      )
    }
  ]

  let loadEmployee = () => {
    ApiService.post('/getEmployees', { EmpIds: EmpIds, date: moment(date).format('YYYY-MM-DD') })
      .then((data) => {
        setEmployee(data[0])
        setLoading(false)
      }).catch(() => {
        setLoading(false)
      })
  }

  let getOvertimeList = () => {
    let selectedShift = employee.overtime_shifts.find((e) => e.Shift_Date == date)
    if(mode === '24'){
      if(shift === 'night'){
        selectedShift = employee.overtime_shifts.find(
          (e) => 
            e.Shift_Date === date && 
            (e.Shift_Code === 3 || e.Shift_Code > 90 && (e.Shift_Type == 'Night'))
        );
      }
      else{
        selectedShift = employee.overtime_shifts.find(
          (e) => 
            e.Shift_Date === date && 
            (e.Shift_Code === 2 || e.Shift_Code > 90 && (e.Shift_Type == 'Day'))
        );
      }
    }
    else{
      if(mode === 'night'){
        selectedShift = employee.overtime_shifts.find(
          (e) => 
            e.Shift_Date === date && 
            (e.Shift_Code === 3 || e.Shift_Code > 90 && (e.Shift_Type == 'Night'))
        );
      }
      else{
        selectedShift = employee.overtime_shifts.find(
          (e) => 
            e.Shift_Date === date && 
            (e.Shift_Code === 2 || e.Shift_Code > 90 && (e.Shift_Type == 'Day'))
        );
      }
    }

    let code = selectedShift.Shift_Code
    if (code > 90) {
      if(mode === '24'){
        if(shift === 'night'){
          code = 3
        }
        else{
          code = 2
        }
      }
      else{
        if(mode === 'night'){
          code = 3
        }
        else{
          code = 2
        }
      }
    }
    ApiService.get(`/todayOvertimeSignup?date=${moment(date).format('YYYY-MM-DD')}&shiftCode=${code}&position=${employee.employee_assignment.Position_Code}`)
      .then((data) => {
        setData(data.data.data)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  let onSubmitAssign = () => {
    if (employee.overtime_shifts && employee.overtime_shifts.length > 0) {
      let selectedShift = employee.overtime_shifts.find((e) => e.Shift_Date == date)
      if(mode === '24'){
        if(shift === 'night'){
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 3 || e.Shift_Code > 90 && (e.Shift_Type == 'Night'))
          );
        }
        else{
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 2 || e.Shift_Code > 90 && (e.Shift_Type == 'Day'))
          );
        }
      }
      else{
        if(mode === 'night'){
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 3 || e.Shift_Code > 90 && (e.Shift_Type == 'Night'))
          );
        }
        else{
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 2 || e.Shift_Code > 90 && (e.Shift_Type == 'Day'))
          );
        }
      }

      const req = {
        "Shift_Number": selectedShift?.Shift_Number,
        "Shift_Date": date,
        "Emp_Code": selectedEmp[0]
      }
			ApiService.post('/hitlistAssignEmp', req)
        .then((res) => {
          loadData(moment(date).format('DD-MM-YYYY'))
          toast.success(res?.message)
          setAssignModal(false)
        }).catch((err) => {
          toast.error(err?.data?.message)
        })
    }
  }

  const onRowSelectionModelChange = (selection) => {
    setSelectedEmp(selection)
  }

  useEffect(() => {
    if (EmpIds && EmpIds.length > 0) {
      loadEmployee()
    }
  }, [EmpIds])

  useEffect(() => {
    if (employee) {
      getOvertimeList()
    }
  }, [employee])

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      // const rank = item?.employee?.employee_assignment?.EA_Rank?.toLowerCase() || "";
      const fullName = item?.employee?.fullName?.toLowerCase() || "";
      // const combinedName = `${rank} ${fullName}`;
  
      return fullName.includes(search.toLowerCase());
    });
  }, [search, data]);


  return (
    <>

      <Paper className='p-4'>
        {!loading &&
          <>
            <Row>
              <Col md={11}>
                <Typography fontWeight={700} fontSize={21} className="mb-3">{moment(date).format("dddd Do MMMM YYYY")}</Typography>
              </Col>
              <Col md={1}>
                <img src='/images/close-icon.svg' onClick={backFunction} style={{ cursor: 'pointer', height: 25 }} />
              </Col>
            </Row>
            <Row className='px-3 mb-2'>
              <TextField
                  variant="outlined"
                  placeholder="Search by Name"
                  className="mt-0 w-100"
                  color='secondary'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      height: '48px',
                      fontSize: '14px'
                    },
                  }}
                />
            </Row>
            {data && data.length > 0 ?
              <div className='border border-1 rounded-2'>
                <div className='d-flex mt-2'>
                  <p className='fw-bolder text-danger px-3' style={{ width: 270 }}>Overtime members</p>
                  <p className='fw-bolder text-danger' style={{ width: 100 }}>Seniority</p>
                  <p className='fw-bolder text-danger' style={{ width: 90 }}>Hours</p>
                  <p className='fw-bolder text-danger'>Available schedule</p>
                </div>
                <div style={{maxHeight:'45vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
                  <MyTable
                    rows={filteredData} 
                    columns={columns}
                    hideFooter={true}
                    showHeader={false}
                    onRowSelectionModelChange={onRowSelectionModelChange}
                    selectedRows={selectedEmp}
                  />
                </div>
              </div>
              :
              <Typography fontWeight={700} fontSize={16} className="mb-3">No results found</Typography>
            }
            <label className='mt-4 mb-2'>Employee</label>
            <TextField
              className="mt-0 w-100"
              color="secondary"
              variant="outlined"
              label=""
              disabled={true}
              value={`${employee?.First_name || ''} ${employee?.Last_name || ''}`}
            />
            <ButtonTheme type='submit' variant="filled" color='primary' className='px-5 mt-4'
              onClick={() => {
                setShow(true);
              }}
              disabled={!selectedEmp || selectedEmp?.length == 0}>
              Assign
            </ButtonTheme>

            <Modal show={show} onHide={handleClose} style={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)'
            }}>
              <Modal.Header closeButton>
                <Modal.Title>Confirm shift assign?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md='auto'>
                    <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={handleClose}>
                      Cancel
                    </ButtonTheme>
                  </Col>
                  <Col md='auto'>
                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={onSubmitAssign}>
                      Yes
                    </ButtonTheme>
                  </Col>
                </Row>
              </Modal.Body>
            </Modal>
          </>
        }
      </Paper>
    </>
  )
}

export function AssignModal(props) {
  const { date, setAssignDataModal, EmpIds, loadData, backFunction ,  shift} = props;
  const [loading, setLoading] = useState(false);
  const [employee, setEmployee] = useState('')
  const [selectedEmp, setSelectedEmp] = useState([])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [search , setSearch] = useState('');
  const mode = localStorage.getItem('mode');
  const EmployeeToSwap = useSelector((state) => state.dashboardReducer.EmployeeToSwap)
  const [selectedName , setSelectedName] = useState('')

  const columns = [
    {
      field: 'name',
      headerName: '',
      width: 270,
      sortable: false,
      renderCell: (params) => (<Typography key={1} fontWeight={600} fontSize={16} className='mx-1'>
        {params?.row?.EA_Rank} {params?.row?.fullName}
      </Typography>)
    },
    {
      field: 'action',
      headerName: '',
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <Chip sx={{
          height: 'auto',
          color: 'red',
          '& .MuiChip-label': {
            display: 'block',
            whiteSpace: 'normal',
          },
        }}
          style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer' }}
          label='Assign Shift'
          color="red"
          onClick={() => {
            setShow(true)
            setSelectedEmp([params?.row?.Emp_Code])
            setSelectedName(params?.row?.EA_Rank + ' ' +  params?.row?.fullName)
          }
          }
        />
      )
    }
  ]
  
  let loadEmployee = () => {
    ApiService.post('/getEmployees', { EmpIds: EmpIds, date: moment(date).format('YYYY-MM-DD') })
      .then((data) => {
        setEmployee(data[0])
        setLoading(false)
      }).catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (EmpIds && EmpIds.length > 0) {
      loadEmployee()
    }
  }, [EmpIds])

  let onSubmitAssign = () => {
    if (employee.overtime_shifts && employee.overtime_shifts.length > 0) {
      let selectedShift = employee.overtime_shifts.find((e) => e.Shift_Date == date)
      if(mode === '24'){
        if(shift === 'night'){
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 3 || e.Shift_Code > 90 && (e.Shift_Type == 'Night'))
          );
        }
        else{
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 2 || e.Shift_Code > 90 && (e.Shift_Type == 'Day'))
          );
        }
      }
      else{
        if(mode === 'night'){
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 3 || e.Shift_Code > 90 && (e.Shift_Type == 'Night'))
          );
        }
        else{
          selectedShift = employee.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 2 || e.Shift_Code > 90 && (e.Shift_Type == 'Day'))
          );
        }
      }

      const req = {
        "Shift_Number": selectedShift?.Shift_Number,
        "Shift_Date": date,
        "Emp_Code": selectedEmp[0],
      }
			ApiService.post('/hitlistAssignEmp', req)
        .then((res) => {
          loadData(moment(date).format('DD-MM-YYYY'))
          toast.success(res?.message)
          setAssignDataModal(false)
        }).catch((err) => {
          toast.error(err?.data?.message)
        })
    }
  }

  const filteredData = useMemo(() => {
    return EmployeeToSwap.filter((item) => {
      const fullName = item?.fullName?.toLowerCase() || "";
      return fullName.includes(search.toLowerCase());
    });
  }, [search, EmployeeToSwap]);


  return (
    <>

      <Paper className='p-4'>
        {!loading &&
          <>
            <Row>
              <Col md={11}>
                <Typography fontSize={16}  fontWeight= {600} className="mb-3">
                  {`Fill for ${employee?.employee_assignment?.Position} on ${moment(date).format("Do MMMM YYYY")}`}
                </Typography>
              </Col>
              <Col md={1}>
                <img src='/images/close-icon.svg' onClick={backFunction} style={{ cursor: 'pointer', height: 25 }} />
              </Col>
            </Row>
            <Row className='px-3 mb-2'>
              <TextField
                  variant="outlined"
                  placeholder="Search by Name"
                  className="mt-0 w-100"
                  color='secondary'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      height: '48px',
                      fontSize: '14px'
                    },
                  }}
                />
            </Row>
            {EmployeeToSwap && EmployeeToSwap.length > 0 ?
              <div className='border border-1 rounded-2'>
                <div className='d-flex mt-2'>
                  <p className='fw-bolder text-danger px-3' style={{ width: 320 }}>Name</p>
                  <p className='fw-bolder text-danger'>Action</p>
                </div>
                <div style={{maxHeight:'45vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
                  <MyTable
                    rows={filteredData}
                    columns={columns}
                    hideFooter={true}
                    showHeader={false}
                    checkboxSelection={false}
                  />
                </div>
              </div>
              :
              <Typography fontWeight={700} fontSize={16} className="mb-3">No results found</Typography>
            }

            <Modal show={show} onHide={handleClose} style={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)'
            }}>
              <Modal.Header closeButton>
                <Modal.Title>Confirm shift assign?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Typography sx={{fontSize:'16px'}}> Are you sure to assign this shift to {selectedName}</Typography>
                </Row>
                <Row>
                  <Col md='auto'>
                    <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={handleClose}>
                      Cancel
                    </ButtonTheme>
                  </Col>
                  <Col md='auto'>
                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={onSubmitAssign}>
                      Yes
                    </ButtonTheme>
                  </Col>
                </Row>
              </Modal.Body>
            </Modal>
          </>
        }
      </Paper>
    </>
  )
}